import { PageTitle } from "../../types/pageTitle";
import { Container, Row } from "react-bootstrap";
import styled from "styled-components";

import PlatformTermsOfUse from "./components/PlatformTermsOfUse_v1_260511";
import { LogoIconDarkText } from "../../common/components/core/icons";


const PlatformAgreementView = (): JSX.Element => {
    document.title = PageTitle.PlatformAgreementView;

return (
    <Container fluid>
        <Row>
            <StyledLogoIcon />
        </Row>
        <StyledMain>
            <h1 className="d-flex justify-content-center">Platform Terms of Use (“Terms”)</h1>
            <PlatformTermsOfUse />
        </StyledMain>
    </Container>
    );
};

const StyledLogoIcon = styled(LogoIconDarkText)`
    width: 200px;
`;
const StyledMain = styled.main`
    padding: 5rem;
`;
export default PlatformAgreementView;
